import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabBar, TabItem } from '../components';

const LandscapeAboutBaseAddTemplate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem title="Participant" id={`/landscapes/add/about`} />
        <TabItem title="Landscape" id={`/landscapes/add/about/landscape`} />
        <TabItem
          title="Committed buyers"
          id={`/landscapes/add/about/committed-buyers`}
        />
        <TabItem
          title="ContactPersons"
          id={`/landscapes/add/about/contact-person`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeAboutBaseAddTemplate;
